export const WEIXIN_API_CONFIG_START = 'WEIXIN_API_CONFIG_START';
export const WEIXIN_API_CONFIG_END = 'WEIXIN_API_CONFIG_END';
